import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SiaSignalrService, SiaUsersService } from '@sia/shared';

@Component({
  selector: 'job3-shell',
  template: `<router-outlet name="base"></router-outlet>`,
  standalone: true,
  imports: [RouterOutlet],
})
export class Job3ShellComponent {
  #siaSignalrService = inject(SiaSignalrService);
  #userService = inject(SiaUsersService);

  ngOnInit() {
    let userData = this.#userService.getUserData();
    if (userData?.id) {
      this.#siaSignalrService.initService(userData.id);
    }
  }
}
